<template>
  <div>
    <div v-show="isActive" ref="backDiv" id="back-div" class="back-overlay"></div>
    <div id="drawer" class="drawer-overlay" :class="{ active: isActive }">
      <a class="clearfix">
        <i @click.prevent="$emit('closed')" class="material-icons md-36">close</i>
      </a>
      <login v-show="isLogin" @show-register="isLogin=false" @close-overlay="close()" />
      <register v-show="!isLogin" @show-login="isLogin=true" @close-overlay="close()" />
    </div>
  </div>
</template>

<script>
import login from "../user/login.vue";
import register from "../user/register.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    login,
    register
  },
  name: "Overlay",

  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    isLogin: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(["user", "currentStoreDoc"])
  },
  watch: {
    isActive() {
      if (this.isActive) {
        this.isLogin = true;
      }
    }
  },
  mounted() {
    var that = this;
    this.$refs.backDiv.onclick = function() {
      if (that.isActive) {
        that.$emit("closed");
      }
    };
  },
  methods: {
    ...mapActions(["logout"]),
    close() {
      if (this.isActive) {
        this.$emit("closed");
      }
    }
  }
};
</script>
